import React, { Component, Fragment } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';

import Header from '../components/Header';
import BoxToggle from '../components/BoxToggle';

class FAQs extends Component {
  state = {
    programa: null,
    recrutamento: null,
    letiva: null,
    consolidacao: null,
    outras: null,
    isLoading: false,
    error: [],
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    Promise.all([
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=9'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=10'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=11'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=12'),
      axios.get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=13'),
    ])
      .then(([response1, response2, response3, response4, response5]) => {
        this.setState({
          programa: response1.data.reverse(),
          recrutamento: response2.data.reverse(),
          letiva: response3.data.reverse(),
          consolidacao: response4.data.reverse(),
          outras: response5.data.reverse(),
          isLoading: false,
        });
      })
      .catch((error) =>
        this.setState({
          error: error,
          isLoading: false,
        })
      );
  }

  render() {
    const { programa, recrutamento, letiva, consolidacao, outras, isLoading } = this.state;

    // console.log(this.state);

    let programaPosts =
      programa !== null && isLoading === false ? (
        programa.map((programaPost) => (
          <BoxToggle
            key={programaPost.id}
            paddBot={true}
            title={programaPost.title.rendered}
            text_opened={
              <div
                className="normal-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(`${programaPost.content.rendered}`),
                }}
              />
            }
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    let recrutamentoPosts =
      recrutamento !== null && isLoading === false ? (
        recrutamento.map((recrutamentoPost) => (
          <BoxToggle
            key={recrutamentoPost.id}
            paddBot={true}
            title={recrutamentoPost.title.rendered}
            text_opened={
              <div
                className="normal-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(`${recrutamentoPost.content.rendered}`),
                }}
              />
            }
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    let letivaPosts =
      letiva !== null && isLoading === false ? (
        letiva.map((letivaPost) => (
          <BoxToggle
            key={letivaPost.id}
            paddBot={true}
            title={letivaPost.title.rendered}
            text_opened={
              <div
                className="normal-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(`${letivaPost.content.rendered}`),
                }}
              />
            }
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    let consolidacaoPosts =
      consolidacao !== null && isLoading === false ? (
        consolidacao.map((consolidacaoPost) => (
          <BoxToggle
            key={consolidacaoPost.id}
            paddBot={true}
            title={consolidacaoPost.title.rendered}
            text_opened={
              <div
                className="normal-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(`${consolidacaoPost.content.rendered}`),
                }}
              />
            }
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    let outrasPosts =
      outras !== null && isLoading === false ? (
        outras.map((outrasPost) => (
          <BoxToggle
            key={outrasPost.id}
            paddBot={true}
            title={outrasPost.title.rendered}
            text_opened={
              <div
                className="normal-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(`${outrasPost.content.rendered}`),
                }}
              />
            }
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    return (
      <Fragment>
        <Header title={'FAQs'} />

        <section className="content">
          <div className="column">
            <div className="blackline">
              <h2>Programa Acertar o Rumo</h2>
              {programaPosts}
            </div>
            <div className="blackline">
              <h2>Recrutamento e Seleção</h2>
              {recrutamentoPosts}
            </div>
            <div className="blackline">
              <h2>Fase de Consolidação nas Empresas</h2>
              {consolidacaoPosts}
            </div>
          </div>
          <div className="column">
            <div className="blackline">
              <h2>Fase Letiva</h2>
              {letivaPosts}
            </div>
            <div className="blackline">
              <h2>Outras</h2>
              {outrasPosts}
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}

export default FAQs;
